export enum EBusinessEntityStep {
  Authorization = 'authorization',

  BusinessEntityCheckData = 'businessEntityCheckData',
  BusinessEntityForm = 'businessEntityForm',
  Insurance = 'insurance',

  Success = 'success',
  Error = 'error',
  Unexpected = 'unexpected',
}
